export const palette = {
  black: '#000000',
  white: '#FFF',
  grey1: '#222222',
  grey2: '#484848',
  grey3: '#959595',
  grey4: '#B3B3B3',
  grey45: '#cccccc',
  grey5: '#f5f5f5',
  green1: '#009b4f',
  green2: '#00693c',
  red1: '#E00034',
  red2: '#D0021B',
  yellow1: '#F7D200',
  blue1: '#2C3E50',
  blue2: '#172737',
  blue3: '#E8EDEE',
  turquoise: '#38c5c3',

};

export default {
  breakpoints: {
    s: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
  palette: {
    colors: palette,
    navbar: {
      color: {
        active: palette.black,
        default: palette.grey3,
      },
    },
    modal: {
      background: palette.black,
      transparency: '80',
      contrastText: palette.black,
    },
    primary: {
      main: palette.green1,
      dark: palette.green2,
      contrastText: palette.white,
    },
    secondary: {
      main: palette.blue1,
      contrastText: palette.white,
    },
    card: {
      title: palette.grey3,
    },
    messages: {
      error: {
        background: palette.red2,
        contrastText: palette.white,
      },
      warning: {
        background: palette.yellow1,
        contrastText: palette.grey1,
      },
      info: {
        background: palette.blue2,
        contrastText: palette.white,
      },
    },
    grey: [
      palette.grey1,
      palette.grey2,
      palette.grey3,
      palette.grey4,
      palette.grey5,
    ],
    text: {
      main: palette.grey1,
      light: palette.grey2,
    },
    background: {
      primary: palette.blue1,
      secondary: palette.blue3,
      paper: palette.white,
    },
    input: {
      label: palette.grey1,
      border: palette.black,
      placeholder: palette.grey4,
      text: palette.black,
      disabled: palette.grey3,
      error: palette.red1,
      focus: palette.green1,
    },
  },
  typography: {
    htmlFontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontFamily: 'source sans pro,Arial,sans-serif;',
    h1: {
      fontFamily: '"Soho Gothic W01", sans-serif',
      fontWeight: 700,
      fontSize: '2rem',
    },
    h2: {
      fontFamily: '"Soho Gothic W01", sans-serif',
      fontWeight: 700,
      fontSize: '1.5rem',
    },
    h3: {
      fontFamily: '"Soho Gothic W01", sans-serif',
      fontSize: '1rem',
      fontWeight: 700,
    },
    small: {
      fontSize: '0.9rem',
    },

    display: {
      fontFamily: '"Soho Gothic W01", sans-serif',
      fontWeight: 400,
    },
  },
  spacing: 8,
  shape: {
    borderRadius: 4,
  },
  zIndex: {
    tooltip: 9,
    header: 50,
    modalDialog: 99,
    modalMenu: 199,
    spinner: 999,
  },
};
